import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { PageType } from '@app/courseContent/courseContent.component';
import { LocalStorageService } from '@shared/services/localStorage.service';
import { getUrlParams } from '@app/utils/url';
import { PlRouter } from '@shared/services/pl-router.service';
import { TOKEN_SURVEY_QUERY_PARAM_KEY } from '@shared/models/step.model';

@Component({
  selector: 'pl-friends-survey',
  templateUrl: './friendsSurvey.component.html',
})
export class FriendsSurveyComponent implements OnInit {
  public friendsSurveyToken: WritableSignal<string | null> = signal(null);

  private readonly KEY_LOCAL_STORAGE_FRIENDS_SURVEY_TOKEN: string = 'friend_survey_token' as const;

  public readonly PageType: typeof PageType = PageType;

  constructor(
    private localStorageService: LocalStorageService,
    private plRouter: PlRouter,
  ) {}

  public ngOnInit(): void {
    const url: string = this.plRouter.url;
    const urlParams: URLSearchParams = new URLSearchParams(getUrlParams(url));
    this.friendsSurveyToken.set(this.extractTokenFromUrl(urlParams));
  }

  private extractTokenFromUrl(urlParams: URLSearchParams): string | null {
    let friendsSurveyToken: string | null = urlParams.get(TOKEN_SURVEY_QUERY_PARAM_KEY);
    if (friendsSurveyToken) {
      this.localStorageService.storeInLocalStorage(this.KEY_LOCAL_STORAGE_FRIENDS_SURVEY_TOKEN, friendsSurveyToken);
    } else {
      friendsSurveyToken = this.localStorageService.getFromLocalStorage(this.KEY_LOCAL_STORAGE_FRIENDS_SURVEY_TOKEN);
    }

    return friendsSurveyToken;
  }
}
